// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error module not typed
import { getAgentId } from 'conversations-message-history/filtered-change-message/operators/filteredChangeMessageGetters';
import { AGENT } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import SystemMessage from '../system-message/SystemMessage';
import FullSenderName from '../senders/components/FullSenderName';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import { chooseThreadFilteredChangeMessage } from './operators/chooseThreadFilteredChangeMessage';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { BlockIcon, ReportSpamIcon } from 'foundations-assets';
import { isBlockMessage, isUnblockMessage
// @ts-expect-error module not typed
} from 'conversations-message-history/filtered-change-message/operators/filteredChangeComparators';
import { jsx as _jsx } from "react/jsx-runtime";
const FilteredChangeMessage = ({
  message,
  senders,
  userId
}) => {
  const senderId = getAgentId(message);
  const senderType = AGENT;
  const asyncSender = findSender(senderId, senderType, senders);
  const isSelfMarker = senderId === userId;
  const marker = !isSelfMarker && /*#__PURE__*/_jsx(FullSenderName, {
    sender: asyncSender && getData(asyncSender)
  });
  const isBlockedMessage = isBlockMessage(message) || isUnblockMessage(message);
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: chooseThreadFilteredChangeMessage({
      message,
      isSelfMarker,
      marker
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: isBlockedMessage ? BlockIcon : ReportSpamIcon,
      size: "500"
    })
  });
};
FilteredChangeMessage.displayName = 'FilteredChangeMessage';
export default FilteredChangeMessage;